module.exports = __webpack_public_path__ + "static/media/photo107.5d5d5a6e.jpg";